import { useEffect, useState } from 'react';
import { Position, Handle } from 'reactflow';
import { Box, Card, Typography, LinearProgress } from '@mui/material';
import ChargingStationOutlinedIcon from '@mui/icons-material/ChargingStationOutlined';
import { green, red, orange } from '@mui/material/colors';

export default function UpsNode({ data }) {
  const [ups, setUps] = useState(data || {});

  useEffect(() => {
    setUps(data || {});
  }, [data]);

  const shadowColor =
    ups.state === 'error'
      ? red[500]
      : ups.state === 'battery'
        ? orange[500]
        : ups.state === 'online'
          ? green[300]
          : 'transparent';

  const borderColor =
    ups.state === 'error'
      ? red[600]
      : ups.state === 'battery'
        ? orange[600]
        : ups.state === 'online'
          ? green[600]
          : 'grey.400';

  const getChargeColor = (charge) => {
    if (charge < 20) return 'error';
    if (charge < 50) return 'warning';
    return 'success';
  };

  const chargeValue = ups.estimatedCharge ?? 0;
  const chargeColor = getChargeColor(chargeValue);

  return (
    <Card
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0 0 20px 1px ${shadowColor}`,
        height: '100%',
        width: '100%',
        position: 'relative',
        minWidth: 230,
        minHeight: 30,
        border: `2px solid ${borderColor}`,
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          noWrap
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {ups.title}
        </Typography>
        <ChargingStationOutlinedIcon
          sx={{
            color: 'white',
            bgcolor: 'grey.300',
            borderRadius: '20%',
            p: 0.5,
            fontSize: 48,
            flexShrink: 0,
          }}
          titleAccess="USV Node"
        />
      </Box>

      <Box>
        <Typography variant="caption" display="block" sx={{ mb: 0.5 }}>
          Batteriestand
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <LinearProgress
            variant="determinate"
            value={chargeValue}
            color={chargeColor}
            sx={{ width: '100%', height: 10, borderRadius: 5 }}
          />
          <Typography variant="body2" fontWeight="bold" sx={{ flexShrink: 0 }}>
            {chargeValue}%
          </Typography>
        </Box>
      </Box>

      <Handle
        type="target"
        position={Position.Top}
        id="ups-target"
        style={{ bottom: -2 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="ups-source"
        style={{ bottom: -2 }}
      />
    </Card>
  );
}
